import { Tooltip, IconButton } from "@mui/material";

import FileDownloadIcon from "@mui/icons-material/FileDownload";

const DownloadButton = ({
  tooltip,
  buildFile,
  fileName,
  children = <FileDownloadIcon />,
}) => {
  const onDownload = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const file = await buildFile();

    // If buildFile returns null, it handled the download itself
    if (!file) {
      return;
    }

    const element = document.createElement("a");
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
    return element.remove();
  };

  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton onClick={onDownload}>{children}</IconButton>
      </span>
    </Tooltip>
  );
};
export default DownloadButton;
